/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from 'react';
import ReactSVG from 'react-svg';
import Truncate from 'react-truncate';
import { decode } from 'html-decoder';
import marker from 'map_marker.svg';
import user from 'user.svg';
import bed from 'bed.svg';
import shower from 'shower.svg';
import chevron from 'chevron-small.svg';
import default_user from 'default_pfp.svg';
import ErrorBoundary from '../ErrorBoundary';

function PropertyOverview({ property, community, city, property_path }) {
  const isSSR = typeof window === 'undefined';

  const [truncated, setTruncated] = useState(true);

  const description = property.full_description
    .split('&lt;br /&gt;')
    .join('<br>');

  const slug = community.url.split('/').splice(-2, 1);

  const cityName = function() {
    if (city && city?.name) {
      return city.name;
    }

    return property.city_prop_name;
  }

  return (
    <section id="overview" className="main-content-section">
      <ul className="property-page-breadcrumb-mobile">
        <li>
          <a
            aria-label="Home Page"
            href={isSSR ? '' : window.Routes.root_path()}
            className="underline secondary-text"
          >
            Home
          </a>
        </li>
        <ReactSVG src={chevron} />
        <li>
          <a
            aria-label={`${cityName()} Page`}
            href={
              isSSR
                ? ''
                : window.Routes.listings_area_type_path({
                    area: property.city_slug || city._her_attributes.name,
                  })
            }
            className="underline secondary-text"
          >
            {city}
          </a>
        </li>
        <ReactSVG src={chevron} />
        <li>
          <a
            aria-label={`${community.name} Page`}
            href={`/${property.city_slug}/vacation-rentals/${slug}`}
            className="underline secondary-text"
          >
            {decode(community.name)}
          </a>
        </li>
        <ReactSVG src={chevron} />
        <li>
          <a
            aria-label={`${decode(property.name)} Show Page`}
            href={property_path}
            className="underline secondary-text"
          >
            <Truncate trimWhitespace>{decode(property.name)}</Truncate>
          </a>
        </li>
      </ul>

      <span className="overview-property-icon-text community">
        <ReactSVG src={marker} />
        {decode(community.name)}
      </span>
      <div className="overview-property-details">
        <span className="overview-property-icon-text">
          <ReactSVG src={user} />
          {property.sleeps} Guests
        </span>
        <span className="overview-property-icon-text">
          <ReactSVG src={bed} />
          {property.beds} Bedrooms
        </span>
        <span className="overview-property-icon-text">
          <ReactSVG src={shower} />
          {property.baths.split('&amp;frac12;').join('1/2')} Bathrooms
        </span>
      </div>
      <section className="overview-property-description">
        <div>
          <div
            className={`${truncated ? 'truncated' : ''}`}
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{
              __html: decode(description),
            }}
          />
        </div>
        <button
          aria-label="Toggle overview truncate"
          name="Toggle overview truncate"
          className="overview-property-description-truncate"
          type="button"
          onClick={() => setTruncated(!truncated)}
        >
          <span>Read {truncated ? 'More' : 'Less'}</span>
          <ReactSVG src={chevron} svgClassName={truncated ? 'truncated' : ''} />
        </button>
      </section>

      <div className="overview-property-owner">
        <img
          data-src={property.property_owner.picture_url || default_user}
          alt="owner-pfp"
          title="Owner Profile Picture"
          className="lazyload"
        />
        <aside>
          <p>Contact</p>
          <p className="owner-name">{decode(property.property_owner.name)}</p>
          <p className="owner-phone">
            <a
              href={`tel:${property.property_owner.phone}`}
              title="Call property owner"
              aria-label="Call property owner"
            >
              {property.property_owner.phone}
            </a>
          </p>
        </aside>
      </div>
    </section>
  );
}

export default function PropertyOverviewWrapper({ ...props }) {
  return (
    <ErrorBoundary>
      <PropertyOverview {...props} />
    </ErrorBoundary>
  );
}
